import React from 'react';
import Dialog from '@react/react-spectrum/Dialog';
import { BannerSeverity } from '../../models/banner/BannerObject';
import SeverityBadge from '../../components/SeverityBadge/SeverityBadge';
import './TemplatePickerDialog.css';

export interface MessageTemplate {
  label: string;
  message: string;
  severity: BannerSeverity;
}

interface TemplatePickerDialogProps {
  isOpen: boolean;
  templates: MessageTemplate[];
  onSelect: (template: MessageTemplate) => void;
  onDismiss: () => void;
}

function TemplatePickerDialog({ isOpen, templates, onSelect, onDismiss }: Readonly<TemplatePickerDialogProps>): React.ReactElement {
  return (
    <Dialog
      className="template-picker-dialog"
      title="Insert Template"
      open={isOpen}
      variant="information"
      isDismissible
      onClose={() => onDismiss()}
    >
      <div className="template-picker-list">
        {templates.map((template) => (
          <button
            key={template.label}
            type="button"
            className="template-picker-row"
            onClick={() => onSelect(template)}
          >
            <span className="template-picker-row-header">
              <b>{template.label}</b>
              <SeverityBadge severity={template.severity} />
            </span>
            <span className="template-picker-preview">{template.message}</span>
          </button>
        ))}
      </div>
    </Dialog>
  );
}

export default TemplatePickerDialog;
